export default __webpack_public_path__ + "static/media/iagomachado.c9d23786.jpeg";